import React from 'react'
import ImageWrap from 'components/ImageWrap'
import HubspotFormWrap from 'components/HubspotFormWrap'
import { isObjectEmpty } from 'js/utils'

export default function ContactBlock({ content }) {
  const { image, copy, hubspotForm } = content

  let i = 0
  const blocks = [image, copy, hubspotForm]
  blocks.forEach((block) => {
    if (!isObjectEmpty(block)) i++
  })

  if (i === 0) {
    // all blocks empty
    return <div />
  }

  return (
    <section className='contact'>
      <Image content={image} />
      <div className='contact__wrap'>
        <Copy content={copy} />
        {!isObjectEmpty(hubspotForm) && <Form content={hubspotForm} />}
      </div>
    </section>
  )
}

const Image = ({ content }) => {
  const { desktop, mobile } = content
  return (
    <div className='bg'>
      {desktop && <ImageWrap className='desktop-only' image={desktop} />}
      {mobile && <ImageWrap className='mobile-only' image={mobile} />}
    </div>
  )
}

const Copy = ({ content }) => {
  const { pretitle, title, description, email } = content
  return (
    <div className='contact__copy'>
      {pretitle && <h6 className='contact__pretitle'>{pretitle}</h6>}
      {title && (
        <h1 className='contact__title  contact__title--default '>{title}</h1>
      )}
      {description && <p className='contact__excerpt'>{description}</p>}
      {email && (
        <h4 className='contact__email'>
          <a className='contact__email-link' href={`mailto:${email}`}>
            {email}
          </a>
        </h4>
      )}
    </div>
  )
}

const Form = ({ content }) => {
  return (
    <div className='contact__form'>
      <HubspotFormWrap content={content} />
    </div>
  )
}
